<template>
  <view class="airflow-train-guide-card extern-class externClass" bindtap="handleClick">
    <view class="guide-card-icon" wx:style="{{iconStyle}}">
      <view wx:if="{{cardIcon}}" class="guide-card-icon-text" wx:style="{{iconDescStyle}}">
        {{ iconDesc }}
      </view>
    </view>
    <view class="guide-card-station-info">
      <view class="station-info">
        {{ departureStation }}
        <Icon
          externClass="right-half-arrow-icon"
          h="4"
          w="32"
          color="#999"
          name="thin-right-arrow"
        />
        {{ arrivalStation }}
      </view>
      <view class="time-info">
        <view class="elapsed-time">
          {{ formatElapsedTime }}
          <view class="line" />
        </view>
        <HlText
          externClass="personalized-copy"
          text="{{personalizedCopy}}"
          color="#666"
          hlColor="#FF6400"
          textStyle="{{textStyle}}"
        />
      </view>
    </view>
    <view class="guide-card-price-info">
      <view class="price-info">
        <Icon size="32" name="rmb-icon" />
        <view class="price-text">{{ ticketPrice }}</view>
      </view>
      <view class="purchase-text"
        >{{ purchaseText }}
        <Icon externClass="right-arrow-icon" size="20" name="right-thin-arrow" />
      </view>
    </view>
  </view>
</template>

<script>
  import mpx, { createComponent } from '@mpxjs/core'
  import { debounce, trackEvent } from '@didi/spring-base'

  const TRACK_TYPE_MAP = {
    1: '比火车省钱',
    2: '比高铁省钱',
    3: '火车无余票',
    4: '比高铁省时',
    5: '比火车省时',
    211: '机票无余票',
    212: '比飞机省钱'
  }
  const BASE_BIZ_CONFIG = {
    train: {
      cnSw: '迎客松-机票-航班列表页-引流banner-曝光',
      cnCk: '迎客松-机票-航班列表页-引流banner-点击',
      enSw: 'yks_plane_listpage_changebanner_sw',
      enCk: 'yks_plane_listpage_changebanner_ck',
      color: '#FF6400'
    },
    flight: {
      cnSw: '迎客松-火车票-车票列表页-引流banner-曝光',
      cnCk: '迎客松-火车票-车票列表页-引流banner-点击',
      enSw: 'yks_train_tickets_changebanner_sw',
      enCk: 'yks_train_tickets_changebanner_ck',
      color: '#169F55'
    }
  }

  createComponent({
    externalClasses: ['extern-class'],
    props: {
      type: {
        type: String,
        value: 'train'
      },
      iconDesc: {
        type: String,
        value: '特惠火车票'
      },
      elapsedTime: {
        type: Number,
        value: 75
      },
      departureStation: {
        type: String,
        value: '北京'
      },
      arrivalStation: {
        type: String,
        value: '上海'
      },
      personalizedCopy: {
        type: String,
        value: '个性化{{文案}}'
      },
      ticketPrice: {
        type: Number,
        value: 100
      },
      cardIcon: {
        type: String,
        value: ''
      },
      purchaseText: {
        type: String,
        value: '去订购'
      },
      trackType: {
        type: Number,
        value: 1
      }
    },
    created() {
      this.handleClick = debounce(
        () => {
          if (this.disabled) {
            return
          }
          trackEvent(BASE_BIZ_CONFIG[this.type].enCk, BASE_BIZ_CONFIG[this.type].cnCk, {
            type: this.trackTypeValue
          })
          this.triggerEvent('click')
        },
        300,
        { leading: true, trailing: false }
      )
      trackEvent(BASE_BIZ_CONFIG[this.type].enSw, BASE_BIZ_CONFIG[this.type].cnSw, {
        type: this.trackTypeValue
      })
    },
    data() {
      return {
        textStyle: {
          // display: 'inline-block',
          // overflow: 'hidden',
          whiteSpace: 'nowrap',
          flex: 'none'
          // textOverflow: 'ellipsis'
        },
        handleClick: null
      }
    },
    computed: {
      iconStyle() {
        return {
          backgroundImage: `url(${this.cardIcon})`
        }
      },
      iconDescStyle() {
        return {
          color: BASE_BIZ_CONFIG[this.type].color
        }
      },
      formatElapsedTime() {
        const days = Math.floor(this.elapsedTime / 1440)
        const hours = Math.floor((this.elapsedTime % 1440) / 60)
        const minutes = this.elapsedTime % 60
        const parts = [
          days > 0 ? `${days}天` : '',
          hours > 0 ? `${hours}小时` : '',
          minutes > 0 ? `${minutes}分` : ''
        ]
          .filter((part) => part)
          .join('')
        return parts || '0分'
      },
      trackTypeValue() {
        return TRACK_TYPE_MAP[this.trackType]
      }
    },
    methods: {}
  })
</script>

<style lang="stylus" scoped>
  .airflow-train-guide-card
    display flex
    justify-content center
    box-sizing border-box
    border-radius 8px
    padding 15px 16px 20px 24px
    background #fff
    .guide-card-icon
      position relative
      width 28px
      height 28px
      background-size 100% 100%
      background-repeat no-repeat
      margin-right 24px
      &-text
        position absolute
        bottom -3px
        left 50%
        line-height 11px
        transform translate(-50%, 100%)
        font-size 11px
        white-space nowrap
        font-family PingFangSC-Medium
        font-weight 500
    .guide-card-station-info
      display flex
      flex-direction column
      overflow hidden
      flex 1
      margin-top 5px
      .station-info
        display flex
        align-items center
        margin-bottom 10px
        font-size 16px
        line-height 1
        color #222
        font-family PingFangSC-Medium
        font-weight 500
        .right-half-arrow-icon
          margin 0 6px
      .time-info
        width 100%
        display flex
        align-items center
        font-size 11px
        line-height 11px
        color #666
        font-family PingFangSC-Regular
        font-weight 400
        .elapsed-time
          position relative
          margin-right 12px
          .line
            position absolute
            top 50%
            right -6px
            width 1px
            height 18px
            background #999
            transform scale(0.5) translateY(-100%)
        .personalized-copy
          font-size 11px
          line-height 1
          display inline-block
          overflow hidden
          white-space nowrap !important
          text-overflow ellipsis
          flex 1
    .guide-card-price-info
      display flex
      flex-direction column
      justify-content space-between
      align-items flex-end
      color #ff6400
      .price-info
        display flex
        align-items flex-end
        .price-text
          font-family Barlow Semi Condensed
          font-size 22px
          line-height 22px
      .purchase-text
        font-size 12px
        line-height 1
        display flex
        align-items center
        .right-arrow-icon
          margin-left 2px
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      Icon: '@didi/spring-icon',
      HlText: '../hl-text/index'
    }
  }
</script>

